const clearSearchTable = state => {
    state.table.page = 1
    state.table.search = ''
    state.request.where = { isDeleted: false }
    state.table.sort = ''
    state.request.searchFields = state.request.defaultSearchFields
  
}
export default { clearSearchTable }
